/**
 * A Person's texts on the company number (piece 21, *Communications seam*;
 * piece 35; decision 5210), the words the phone's conversation and the
 * website's Texts tile share, spread into the one lookup in `strings.ts`.
 * 🔨 This file imports nothing, because the lookup imports it.
 */
export const TEXT_THREAD_STRINGS = {
  'textThread.empty': 'No texts yet. A text sent here leaves from the company number.',
  'textThread.noLine': 'This person has no mobile line, so no text can be sent from here.',
  'textThread.boxTo': 'Text to {number}',
  'textThread.placeholder': 'Write a text',
  'textThread.send': 'Send',
  'textThread.sending': 'Sending…',
  'textThread.notSent': 'The text was not sent.',
  'textThread.received': 'Received',
  'textThread.status.queued': 'Queued',
  'textThread.status.sent': 'Sent',
  'textThread.status.delivered': 'Delivered',
  'textThread.status.failed': 'Failed',
  'textThread.status.undeliverable': 'Undeliverable',
  'textThread.status.unknown': 'No Receipt',
} as const;
